import { useState } from 'react'
import { cn } from '@saas-pages/shared/ui'
import { LocalizedProcessingBadge, useT } from '@/shared/i18n'

export function IndexPage() {
  const t = useT()
  const [query, setQuery] = useState('')
  const needle = query.trim().toLocaleLowerCase()
  const groups = t.index.groups
    .map((group) => ({
      ...group,
      tools: t.index.tools.filter(
        (tool) =>
          tool.group === group.key &&
          [tool.title, tool.description, ...tool.formats]
            .join(' ')
            .toLocaleLowerCase()
            .includes(needle),
      ),
    }))
    .filter((group) => group.tools.length > 0)

  return (
    <div className="mx-auto max-w-6xl">
      <header className="pb-3 sm:pb-6 sm:pt-2">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h1 className="text-2xl font-bold tracking-normal sm:text-4xl">{t.index.title}</h1>
          <LocalizedProcessingBadge variant="local" />
        </div>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-muted-foreground sm:mt-3 sm:text-base">
          {t.index.description}
        </p>
      </header>

      <input
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={t.index.searchPlaceholder}
        aria-label={t.index.searchPlaceholder}
        className="w-full rounded-md border bg-background px-3 py-2.5 text-base outline-none focus-visible:ring-2 focus-visible:ring-ring sm:max-w-md sm:text-sm"
      />

      <div id="tools" className="scroll-mt-24">
        {groups.map((group) => (
          <section key={group.key} className="mt-5 sm:mt-8">
            <h2 className="text-lg font-semibold tracking-normal">{group.title}</h2>
            <ul
              className={cn(
                'mt-2 grid gap-2 sm:grid-cols-2 lg:grid-cols-3',
                group.key === 'open' ? 'grid-cols-2' : 'grid-cols-1',
              )}
            >
              {group.tools.map((tool) => (
                <li key={tool.href} className="min-w-0">
                  <a
                    href={tool.href}
                    className="block h-full rounded-md border bg-card px-3 py-2.5 outline-none transition-colors hover:border-foreground/30 hover:bg-accent/45 focus-visible:ring-2 focus-visible:ring-ring"
                  >
                    <span className="block font-medium tracking-normal">{tool.title}</span>
                    <span
                      className={cn(
                        'mt-0.5 line-clamp-2 text-sm leading-5 text-muted-foreground',
                        group.key === 'open' ? 'hidden sm:block' : 'block',
                      )}
                    >
                      {tool.description}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </section>
        ))}
        {groups.length === 0 && (
          <p className="mt-6 text-sm leading-6 text-muted-foreground" role="status">
            {t.index.searchEmpty}
          </p>
        )}
      </div>
    </div>
  )
}
